import request from "@/utils/request";


/**
 * 获取人员、部门树
 * @param params
 * @returns {Promise}
 */
export function getDeptUserTreeAll(params) {
    return request({
        url: '/system/user/getDeptUserTree2',
        method: 'get',
        params
    })
}

/**
 * 根据userId 获取人员详情
 * @param {userId}
 * @returns {Promise}
 */
export function getUser(params) {
    return request({
        url: '/system/user/getUser',
        method: 'get',
        params
    })
}

/**
 * 根据userId 获取人员所属部门
 * @param {userId}
 * @returns {Promise}
 */
export function getCurrentUserDept(params) {
    return request({
        url: '/system/dept/getCurrentUserDept',
        method: 'get',
        params
    })
}

// 根据projectMember 获取人员所属项目列表
export function selectMyProjectList(params) {
    return request({
        url: '/project/project/selectMyProjectList',
        method: 'get',
        params
    })
}

// 根据人员id获取核算公司列表
export function getUserPayCompany(params) {
    return request({
        url: '/hrm/payCompany/getUserPayCompany',
        method: 'get',
        params
    })
}

// 获取部门树
export function deptTree(params) {
    return request({
        url: '/system/user/deptTree',
        method: 'get',
        params
    })
}

// 用户密码重置
export function resetUserPwd(userId, password) {
    const data = {
        userId,
        password
    }
    return request({
        url: '/system/user/resetPwd',
        method: 'put',
        data: data
    })
}
